import { LoadingButton } from '@mui/lab';
import { Input } from 'components/SignInput';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { resetPassword } from 'services/clients/user';
import { validateEmail } from 'services/helpers/user';

interface Props {
  onSuccess: () => void;
}

interface FormValues {
  email: string;
}

export const Form: React.FC<Props> = (props) => {
  const sendResetEmail = useMutation(resetPassword);
  const { register, formState, handleSubmit, setError } = useForm<FormValues>({ mode: 'all' });

  const onSubmit = handleSubmit(async (values) => {
    try {
      await sendResetEmail.mutateAsync(values);
      props.onSuccess();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.error(err);
      if (err.email) {
        setError('email', { message: err.email[0] });
      }
    }
  });

  return (
    <form onSubmit={onSubmit} className="w-full max-w-[500px] space-y-8">
      <Input
        type="email"
        label="Email*"
        inputProps={register('email', {
          required: true,
          validate: {
            validate: (v) => (validateEmail(v) ? true : 'Invalid email address'),
          },
        })}
        error={formState.errors.email}
      />
      <LoadingButton
        fullWidth
        type="submit"
        disabled={!formState.isValid}
        loading={formState.isSubmitting}
        variant="contained"
      >
        <h3>Send Reset Email</h3>
      </LoadingButton>
    </form>
  );
};
